export default __webpack_public_path__ + "static/media/ico-time.1e587ad1.svg";